<template>
  <v-row justify="center" class="mt-3">
    <v-pagination
      :value="params.page"
      :length="totalPages"
      :total-visible="10"
      @input="pageChanged"
    ></v-pagination>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { SET_PAGE } from "../../../utils/constants";
export default {
  name: "Pagination",
  computed: {
    ...mapGetters("Table", ["params", "totalPages"])
  },
  methods: {
    ...mapMutations("Table", [SET_PAGE]),
    pageChanged(page) {
      this.SET_PAGE(page);
      this.$emit("handlePageChanged");
    }
  }
};
</script>

<style></style>
